import React, {  } from 'react'
import { DataCardCell } from '../../types/constants.types'
import classNames from 'classnames';

type DataCardProps = {
  data: DataCardCell[];
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => void;
}

export default function DataCard({data, onClick}: DataCardProps) {

  const getDataValue = (name:string): DataCardCell | undefined => {
    return data.find(d=>d.name === name)
  }

  return (
    <div className="flex-1 flex-col h-[35rem] rounded-lg mb-5 gap-2 shadow-lg bg-white" onClick={e=>onClick(e, getDataValue("name")?.value?.toString() || '')}>    
      <div>
       {getDataValue("name")?.value}
      </div>
      <div className="ml-3 mr-3 mt-3">
      {getDataValue("title")?.value}
      </div>
      <div className="ml-3 mr-3 ">
      {getDataValue("subtitle")?.value}
      </div>
      <div className="ml-3 mr-3 mt-">
      {getDataValue("details")?.value}
      </div>
      <div className={classNames(getDataValue("impact")?.style, "ml-3 mr-3 mt-3")}>
      {getDataValue("impact")?.value}
      </div>
    </div>
  )
}
